module.exports = __webpack_public_path__ + "img/__icon_COILMULDE.3c2df7f4.svg";